// 環境変数でメニュー内機能の表示可否を制御
export const SHOW_MENU_ICON_DISPLAY_SETTINGS =
  process.env.REACT_APP_SHOW_MENU_ICON_DISPLAY_SETTINGS === "true";

export const SHOW_MENU_LINK_LIST =
  process.env.REACT_APP_SHOW_MENU_LINK_LIST === "true";
